import $ from "jquery";
import alertElica from "./alert";

export default function (target) {
    $(target).on('change', 'input, select, textarea', function () {
        let data = new FormData();
        data.append('id', target.dataset.id);
        let inputElements = $(target).find("input,select,textarea").serializeArray();
        for (var key in inputElements) {
            data.append($("[name=" + inputElements[key].name + "]").data("name"), inputElements[key].value);
        }
        //File data
        var file_data = $(target).find('input[data-name="receipt"]').get(0).files;
        for (var i = 0; i < file_data.length; i++) {
            data.append("receipt", file_data[i]);
        }

        $(target).find('input, select, textarea').each(function () {
            $(this).removeClass('is-invalid');
            if ($(this).next().hasClass('invalid-feedback')) {
                $(this).next().remove();
            }
        });

        $.ajax({
            url: updateProductUrl,
            method: "POST",
            data: data,
            processData: false,
            contentType: false,
            success: function (result) {
            },
            error: function (xhr) {
                let response = JSON.parse(xhr.responseText);
                if (typeof response['errors'] !== "undefined") {
                    for (var key in response['errors']) {
                        let $field = $(target).find('[data-name=' + key + ']:eq(0)');
                        $field.addClass('is-invalid');
                        if (!$field.next().hasClass('invalid-feedback')) {
                            $field.after(
                                '<div id="validation' + key + 'Feedback" class="invalid-feedback">' +
                                response['errors'][key] +
                                '</div>'
                            );
                        }
                    }
                }
                if (typeof response['error'] !== "undefined") {
                    alertElica(response['message']);
                    window.location.href = homeUrl;
                }
            }
        });
    });
}
